import React from "react";
import { Link } from "react-router-dom";
import swal from "sweetalert";
import axios from "axios";
import BASE_URL from "../../assets/global/url";
import useDecodeToken from "../../hooks/customHook/useDecodeToken";
import CalculateLatestBalance from "./components/calculateLastBalance";
import AccountBalanceAudit from "./components/accountBalanceAudit";

const SUPER_ADMIN_ID = "11111111-1111-1111-1111-111111111111";

// Technical Tools — admin-only data checking and fixing tools
const Technical_Tools = () => {
  const userLoggedID = useDecodeToken();

  // para sa migrated data na wala pang inventory journal, gagawan ng inventory journal with 0 quantity and 0 amount para ma tag sa product
  const createInventoryJournal = async () => {
    swal({
      icon: "warning",
      title: "Are you sure?",
      buttons: ["Cancel", "OK"],
      dangerMode: true,
    }).then(async (confirm) => {
      if (confirm) {
        try {
          const res = await axios.post(
            `${BASE_URL}/migration/syncCreateInventoryJournal`,
          );
          if (res.status === 200) {
            swal({
              icon: "success",
              title: "Successful",
            });
          }
        } catch (error) {
          console.error(error);
        }
      }
    });
  };

  const startAlignment = async () => {
    swal({
      icon: "warning",
      title: "Are you sure?",
      buttons: ["Cancel", "OK"],
      dangerMode: true,
    }).then(async (confirm) => {
      if (confirm) {
        try {
          const res = await axios.post(`${BASE_URL}/migration/syncLiabilities`);
          if (res.status === 200) {
            swal({
              icon: "success",
              title: "Successful",
            });
          }
        } catch (error) {
          console.error(error);
        }
      }
    });
  };

  const CheckProductionRawMatss = async () => {
    swal({
      icon: "warning",
      title: "Are you sure?",
      text: "Check production raw mattss",
      buttons: ["Cancel", "OK"],
      dangerMode: true,
    }).then(async (confirm) => {
      if (confirm) {
        try {
          const res = await axios.post(
            `${BASE_URL}/migration/checkRawMaterials`,
          );
          if (res.status === 200) {
            swal({
              icon: "success",
              title: "Successful",
            });
          }
        } catch (error) {
          console.error(error);
        }
      }
    });
  };

  const Check_Accounts = async () => {
    swal({
      icon: "warning",
      title: "Are you sure?",
      text: "Check Accounts",
      buttons: ["Cancel", "OK"],
      dangerMode: true,
    }).then(async (confirm) => {
      if (confirm) {
        try {
          const res = await axios.post(
            `${BASE_URL}/migration/checkAccountsNotSameLastAccountBalance`,
          );
          if (res.status === 200) {
            swal({
              icon: "success",
              title: "Successful",
            });
          }
        } catch (error) {
          console.error(error);
        }
      }
    });
  };

  const tagALLVendor = () => {
    swal({
      icon: "warning",
      title: "Are you sure?",
      buttons: ["Cancel", "OK"],
      dangerMode: true,
    }).then(async (confirm) => {
      if (confirm) {
        try {
          const res = await axios.post(`${BASE_URL}/migration/tagALLVendor`);

          if (res.status === 200) {
            swal({
              icon: "success",
              title: "Successful",
            });
          }
        } catch (error) {
          console.error(error);
        }
      }
    });
  };

  const syncProduction = async () => {
    try {
      const sync = await swal({
        icon: "warning",
        title: "Are you sure?",
        buttons: ["Cancel", "OK"],
        dangerMode: true,
      });

      if (!sync) return;

      const res = await axios.post(`${BASE_URL}/migration/sync-production`);

      if (res.status === 200) {
        swal({
          icon: "success",
          title: "Successful",
          text: "Production has been successfully sync.",
        });
      }
    } catch (error) {
      if (error.response && error.response.status === 400) {
        swal({
          icon: "error",
          title: error.response.data.title,
          text: error.response.data.message,
        });

        return;
      }

      console.error(error);
    }
  };

  const syncPurchaseOrder = async () => {
    try {
      const sync = await swal({
        icon: "warning",
        title: "Are you sure?",
        buttons: ["Cancel", "OK"],
        dangerMode: true,
      });

      if (!sync) return;

      const res = await axios.post(`${BASE_URL}/migration/sync-purchase-order`);

      if (res.status === 200) {
        swal({
          icon: "success",
          title: "Successful",
          text: "Purchase Order has been successfully sync.",
        });
      }
    } catch (error) {
      if (error.response && error.response.status === 400) {
        swal({
          icon: "error",
          title: error.response.data.title,
          text: error.response.data.message,
        });

        return;
      }

      swal({
        icon: "error",
        title: "Something went wrong.",
      });

      console.error(error);
    }
  };

  const syncStartSearchPO = async () => {
    try {
      const sync = await swal({
        icon: "warning",
        title: "Are you sure?",
        buttons: ["Cancel", "OK"],
        dangerMode: true,
      });

      if (!sync) return;

      await axios.post(`${BASE_URL}/migration/check_payableIFSame`);
    } catch (error) {
      return console.log(error);
    }
  };

  const syncStartSearchSI = async () => {
    try {
      const sync = await swal({
        icon: "warning",
        title: "Are you sure?",
        buttons: ["Cancel", "OK"],
        dangerMode: true,
      });

      if (!sync) return;

      await axios.post(`${BASE_URL}/migration/check_SI_IFSame`);
    } catch (error) {
      return console.log(error);
    }
  };

  const syncStartSearchExpenses = async () => {
    try {
      const sync = await swal({
        icon: "warning",
        title: "Are you sure?",
        buttons: ["Cancel", "OK"],
        dangerMode: true,
      });

      if (!sync) return;

      await axios.post(`${BASE_URL}/migration/check_ExpensesIFSame`);
    } catch (error) {
      return console.log(error);
    }
  };

  const toolGroups = [
    {
      title: "Inventory & Products",
      tools: [
        {
          description: "Create Inventory Journal to products without with only 0",
          label: "Create Journal",
          onClick: createInventoryJournal,
        },
        {
          description: "Tag All Vendor per product",
          label: "TAG ALL",
          onClick: tagALLVendor,
        },
        {
          description: "Decrement production raw materials from stock management",
          label: "Sync Production",
          onClick: syncProduction,
        },
        {
          description:
            "Check for Production raw mats na approve and d nag log sa Inventory Journal",
          label: "Check Production Raw Mats",
          onClick: CheckProductionRawMatss,
        },
        {
          description: "Create payable product for PO",
          label: "Sync Purchase Order",
          onClick: syncPurchaseOrder,
        },
      ],
    },
    {
      title: "Journal Checks (Approve only)",
      tools: [
        {
          description:
            "Check not same Total Amount on Payable and Payable journal",
          label: "Start Search",
          onClick: syncStartSearchPO,
        },
        {
          description: "Check not same Total Amount on Sales and Sales journal",
          label: "Start Search",
          onClick: syncStartSearchSI,
        },
        {
          description:
            "Check not same Total Amount on Expenses and Expenses journal",
          label: "Start Search",
          onClick: syncStartSearchExpenses,
        },
      ],
    },
    {
      title: "Accounts",
      tools: [
        {
          // ni realign kasi Old na function ng receiving check LOAN pag claim tsaka na siya mag reflect sa account ng liability at Asset
          // ngayon pag add palang ng receving check meron na agad sa liability at sa receiving check ng final balance sheet then pag claim tsaka na siya ma reflect sa asset na mga account if ano naka pili during e claim
          description: "Re-align Receiving Check for loan",
          label: "Re-align Receiving Check",
          onClick: startAlignment,
        },
        {
          description: "Check account what not same with Last Account Balance",
          label: "Check Accounts",
          onClick: Check_Accounts,
        },
      ],
    },
  ];

  if (userLoggedID !== SUPER_ADMIN_ID) {
    return (
      <div className="h-100 w-100 border bg-white custom-container p-4">
        You are not allowed to access this page.
      </div>
    );
  }

  return (
    <div className="h-100 w-100 border bg-white custom-container">
      <div className="container-fluid">
        <div className="w-100 p-2 d-flex flex-column title-custom">
          <span className="fs-3">
            <Link to="/migration" className="text-dark mx-2">
              <i className="fa-solid fa-arrow-left"></i>
            </Link>
            Technical Tools
          </span>
        </div>

        {toolGroups.map((group) => (
          <div key={group.title} className="card shadow-sm m-3">
            <div className="card-header fw-bold">{group.title}</div>
            <ul className="list-group list-group-flush">
              {group.tools.map((tool) => (
                <li
                  key={tool.description}
                  className="list-group-item d-flex justify-content-between align-items-center gap-3"
                >
                  <span>{tool.description}</span>
                  <button
                    className="btn btn-primary text-nowrap"
                    onClick={tool.onClick}
                  >
                    {tool.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>
        ))}

        <div className="card shadow-sm m-3">
          <div className="card-header fw-bold">Account Balances</div>
          <div className="card-body">
            <AccountBalanceAudit />
            <hr />
            <CalculateLatestBalance />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Technical_Tools;
